(function (Drupal, $) {
  // Every lookup below stays inside the styled form the behavior is attached
  // to, so a page with more than one listing only submits the form you used.
  Drupal.behaviors.newsroomViewForm = {
    attach: function attach(context) {
      once('newsroom-view-form', '.newsroom__styled-form', context).forEach(function (form) {
        var $form = $(form);

        // Sets one field of the hidden Views exposed form and submits it.
        function submitWith(selector, value) {
          $form.find('[data-drupal-selector="' + selector + '"]').val(value);
          $form.find('.form-actions input').first().click();
        }

        function submitSort(sortBy, sortOrder) {
          $form.find('[data-drupal-selector="edit-sort-by"]').val(sortBy);
          submitWith('edit-sort-order', sortOrder);
        }

        // Expand filters
        var $plus = $form.find('.newsroom__styled-form__filters.plus');
        var $minus = $form.find('.newsroom__styled-form__filters.minus');
        $plus.on('click', function () {
          $(this).parents('.block-views').first().addClass('newsroom__filter__open');
          $(this).attr('aria-expanded', 'true');
          $minus.attr('aria-expanded', 'true');
        });
        $minus.on('click', function () {
          $(this).parents('.block-views').first().removeClass('newsroom__filter__open');
          $(this).attr('aria-expanded', 'false');
          $plus.attr('aria-expanded', 'false');
        });

        // Type and topic filters. Each option is a visually hidden radio
        // followed by its label. A click on the label applies the option, or
        // clears the filter when that option is already applied.
        function bindOptionFilter(groupSelector, field) {
          var $group = $form.find(groupSelector);

          function apply($label) {
            submitWith(field, $label.hasClass('clicked') ? 'All' : $label.data('value'));
          }

          $group.find('label[data-value]').on('click', function () {
            apply($(this));
          });

          // Enter on a focused radio does what a click on its label does. On
          // the Diversity listing each radio sits in its own wrapper, so the
          // radios are found at any depth and the label next to each one.
          $group.find('input[type="radio"]').on('keydown', function (event) {
            if (event.key !== 'Enter') {
              return;
            }
            var $label = $(this).siblings('label[for="' + this.id + '"]').first();
            if ($label.length) {
              event.preventDefault();
              apply($label);
            }
          });
        }

        bindOptionFilter('.newsroom__styled-form__filters__additional__type__options', 'edit-field-article-type-target-id');
        bindOptionFilter('.newsroom__styled-form__filters__additional__topic', 'edit-field-news-article-topics-target-id');

        // Key word title search filter
        var $search = $form.find('#pretty-search');
        $form.find('.newsroom__styled-form__search__icon').on('click', function () {
          submitWith('edit-title', $search.val());
        });
        $search.on('keypress', function (event) {
          var keycode = (event.keyCode ? event.keyCode : event.which);
          if (keycode === 13) {
            submitWith('edit-title', $search.val());
          }
        });

        // The rest of this behavior drives the Sort By control. A listing
        // without one, such as the Pancake Press, stops here.
        var container = form.querySelector('.custom-select');
        var trigger = form.querySelector('.newsroom__styled-form__sort__expand');
        var selectedText = form.querySelector('#selected__sort_by');
        var optionsList = form.querySelector('.custom-select .newsroom__styled-form__sort__options');
        var options = form.querySelectorAll('.custom-select .newsroom__styled-form__sort__options li');
        var isExpanded = false;
        // The option the control showed when the list opened, so closing the
        // list without sorting can put it back after the arrow keys moved
        // the selection.
        var openedWith = null;

        if (!container || !trigger || !selectedText || !optionsList || !options.length) {
          return;
        }

        // Sort by mouse click controls
        $(optionsList).find('#most-recent').on('click', function () {
          submitSort('created', 'DESC');
        });
        $(optionsList).find('#oldest-first').on('click', function () {
          submitSort('created', 'ASC');
        });
        $(optionsList).find('#a-z').on('click', function () {
          submitSort('title', 'ASC');
        });

        // Handle keyboard and mouse interactions on the trigger bar
        trigger.addEventListener('keydown', handleTriggerKeypresses);
        trigger.addEventListener('click', handleTriggerClick);

        // Select options when they are clicked
        options.forEach(function (option) {
          option.addEventListener('click', function () {
            selectOption(option);
            collapseOptions();
            trigger.focus();
          });
        });

        // Collapse the dropdown when the user clicks off. A Views AJAX
        // refresh removes the form, so the listener lets go of it then.
        document.addEventListener('click', handleBodyClick);

        /**
         Event handlers
         */
        function handleTriggerKeypresses(e) {
          switch (e.key) {
            case 'ArrowUp':
              e.preventDefault();
              if (isExpanded) {
                selectPreviousOption();
              } else {
                expandOptions();
              }
              break;

            case 'ArrowDown':
              e.preventDefault();
              if (isExpanded) {
                selectNextOption();
              } else {
                expandOptions();
                selectFirstOption();
              }
              break;

            case 'Home':
              if (isExpanded) {
                selectFirstOption();
              }
              break;

            case 'End':
              if (isExpanded) {
                selectLastOption();
              }
              break;

            case 'Tab':
              cancelOptions();
              break;

            case 'Escape':
              // Close the list without sorting.
              if (isExpanded) {
                e.preventDefault();
                cancelOptions();
              }
              break;

            case 'Enter':
              if (isExpanded) {
                // Stop the button from also turning Enter into a click,
                // which would open the list again.
                e.preventDefault();
                var selectedEl = currentOption();
                // Trigger the sort
                if (selectedEl) {
                  $(selectedEl).click();
                }
                collapseOptions();
              }
              break;
          }
        }

        function handleBodyClick(e) {
          if (!document.body.contains(form)) {
            document.removeEventListener('click', handleBodyClick);
            return;
          }
          if (!container.contains(e.target) && isExpanded) {
            cancelOptions();
          }
        }

        function handleTriggerClick() {
          if (isExpanded) {
            cancelOptions();
            trigger.focus();
          } else {
            expandOptions();
          }
        }

        /**
         Show/hide option list
         */
        // The list starts with the "closed" class from the template, and
        // the stylesheet hides it while that class is on, so both classes
        // change together.
        function collapseOptions() {
          trigger.setAttribute('aria-expanded', false);
          optionsList.classList.remove('is-visible');
          optionsList.classList.add('closed');
          isExpanded = false;
        }

        function expandOptions() {
          openedWith = { text: selectedText.innerHTML, option: currentOption() };
          trigger.setAttribute('aria-expanded', true);
          optionsList.classList.add('is-visible');
          optionsList.classList.remove('closed');
          isExpanded = true;
        }

        // Closes the list without sorting. Only Enter and a click on an
        // option sort, so every other way of closing the list goes back to
        // the sort that is still applied.
        function cancelOptions() {
          if (!isExpanded) {
            return;
          }
          restoreOpenedOption();
          collapseOptions();
        }

        function restoreOpenedOption() {
          if (!openedWith) {
            return;
          }
          if (openedWith.option) {
            selectOption(openedWith.option);
          }
          else {
            unselectAllOptions();
            trigger.removeAttribute('aria-activedescendant');
          }
          selectedText.innerHTML = openedWith.text;
        }

        /**
         Option selection
         */
        function currentOption() {
          var id = trigger.getAttribute('aria-activedescendant');
          return Array.prototype.filter.call(options, function (option) {
            return option.id === id;
          })[0];
        }

        function selectFirstOption() {
          selectOption(options[0]);
        }

        function selectLastOption() {
          selectOption(options[options.length - 1]);
        }

        function selectNextOption() {
          var currentOptionIndex = Array.prototype.indexOf.call(options, currentOption());
          if (currentOptionIndex + 1 < options.length) {
            selectOption(options[currentOptionIndex + 1]);
          }
        }

        function selectPreviousOption() {
          var currentOptionIndex = Array.prototype.indexOf.call(options, currentOption());
          if (currentOptionIndex - 1 >= 0) {
            selectOption(options[currentOptionIndex - 1]);
          }
        }

        function selectOption(option) {
          unselectAllOptions();
          option.setAttribute('aria-selected', true);
          trigger.setAttribute('aria-activedescendant', option.getAttribute('id'));
          selectedText.innerHTML = option.innerHTML;
        }

        function unselectAllOptions() {
          options.forEach(function (option) {
            option.removeAttribute('aria-selected');
          });
        }
      });
    }
  };
})(Drupal, jQuery);
